// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"389":"bc12fad8","397":"cdaf7727","816":"fa2702d8","920":"64cdeaf2"}[chunkId] + ".chunk.js";
};